import { render } from "./ModalDeEdicao.vue?vue&type=template&id=1591261f&scoped=true"
import script from "./ModalDeEdicao.vue?vue&type=script&lang=js"
export * from "./ModalDeEdicao.vue?vue&type=script&lang=js"

import "./ModalDeEdicao.vue?vue&type=style&index=0&id=1591261f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1591261f"]])

export default __exports__